import React from "react";
import ButtonStyles from "../../../../styles/components/ButtonStyles";
import { StyledDefaultButtonLink } from "../../../../styles/pages/AcademicActivityPlanStyles";
import { StyledBtnsContainer } from "../../../../styles/pages/Workflows/InformationTach";
import { useTachDocWorkflow } from "../../../../context/TachDocumentContext";
import GenericUtils from "../../../../utils/GenericUtils";

const { BtnPrimary } = ButtonStyles;

type ButtonActions = {
    back: () => void;
    action: () => void;
    status?: boolean;
};

const ActionsTachModal = ({ back, action, status }: ButtonActions) => {
    const { check, setCheck, justification } = useTachDocWorkflow();
    const user = GenericUtils.getUser();

    const backNavigation = () => {
        setCheck(false);
        back();
    };

    const validJustify = justification.length > 0;
    const checkAndValidJustify = user.isDac ? check && validJustify : check;

    return (
        <StyledBtnsContainer>
            <StyledDefaultButtonLink variant="link" onClick={backNavigation}>
                Voltar
            </StyledDefaultButtonLink>
            <BtnPrimary
                disabled={status ? !validJustify : !checkAndValidJustify}
                onClick={action}
            >
                {status ? "Cancelar TACH" : "Aprovar TACH"}
            </BtnPrimary>
        </StyledBtnsContainer>
    );
};

export default ActionsTachModal;
